import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import {deepCopyObject, showAxiosError} from "../../util/Helpers";
import SweetAlert from "react-bootstrap-sweetalert";
import '../memberList/MemberList.css';
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import Table from "../../components/Table/Table";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import EditMemberAccrualModal from "./EditMemberAccrualModal";
import Alert from "react-s-alert";
import {Button, Dropdown, Menu} from "antd";
import Icon from "antd/es/icon";
import AccuralDeleteModal from "./AccuralDeleteModal";

class MemberAccrualsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            loading: false,
            isLoading: false,
            searching: false,
            searchQuery: undefined,
            accruals: [],
            alert: null,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            isOpen: false,
            mode: 'edit',
            addDeleteModal:false,
            selectedAccrual:null
        };

        this.cancelProcess = this.cancelProcess.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.addAccrual = this.addAccrual.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.listAccruals = this.listAccruals.bind(this);
        this.cancelMemberAccrualModal = this.cancelMemberAccrualModal.bind(this);

    }

    componentDidMount() {
        if (this.props.selectedCity) {
            let selectedCity = deepCopyObject(this.props.selectedCity);
            this.setState({selectedCity});
        }
    }


    onChangeSelect(name, value) {
        let toBranch;
        if (value === null) {
            toBranch = null
        } else {
            toBranch = value.value;
        }
        this.setState({toBranch});
    }

    addAccrual() {
        this.setState({
            isOpen: true,
            mode: 'create'
        });
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    handleEdit(item) {
        let self = this;
        let selectedAccrual = deepCopyObject(item);
        self.setState({
            selectedAccrual,
            isOpen: true,
            mode: 'edit'
        });
    }

    handleDelete(item) {
        this.setState({
            selectedAccrual: item,
            addDeleteModal: true
        })
    }

    listAccruals(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=relatedYear,id,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: API_BASE_URL + '/accrual/fetchAccurals?page=' + page + '&size=' + size + sortStr + searchQuery + '&memberId=' + this.props.memberId,
            method: "get",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let accruals = (response.data && response.data.page) ? response.data.page.content : [];
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.page.totalElements,
                    accruals,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    cancelMemberAccrualModal() {
        this.setState({
            isOpen: false,
            addDeleteModal: false,
            memberId: null,
        });
        this.listAccruals(undefined, '', this.state.page, this.state.size);
    }

    render() {
        const menu = (
            <Menu>
                <Menu.Item onClick={() => this.handleEdit(this.state.selectedItem)}>
                    Aidat Düzenle
                </Menu.Item>
                <Menu.Item onClick={() => this.handleDelete(this.state.selectedItem)}>
                    Aidat Silme
                </Menu.Item>
            </Menu>
        );

        const columns = [
            {
                Header: "Ad",
                accessor: "member.ad",
                sortable: false,
                Cell: item => (
                    <label>{item.member.ad}</label>)
            },
            {
                Header: "Soyad",
                accessor: "member.soyad",
                sortable: false,
                Cell: item => (
                    <label>{item.member.soyad}</label>)
            },
            {
                Header: "Sicil No",
                accessor: "member.odaSicilNo",
                sortable: false,
                Cell: item => (
                    <label>{item.member.odaSicilNo}</label>)
            },
            {
                Header: "Üyelik",
                accessor: "member.uyelikAktif",
                sortable: false,
                Cell: item => (
                    <label>{item.member.uyelikAktif && item.member.uyelikAktif === true ? "Aktif" : "Pasif"}</label>)
            },
            {
                Header: "Tahakkuk Tipi",
                accessor: "accrualType",
                sortable: false,
                Cell: item => (
                    <label>{(item.accrualType === "RegistrationFee") ? "O. Giriş Aidatı" : "Yıllık Aidat"}</label>)
            },
            {
                Header: "Dönem",
                accessor: "relatedYear",
                sortable: false,
            },
            {
                Header: "Tutar",
                accessor: "amount",
                sortable: false,
                Cell: item => (<label>{item.amount && item.amount + " ₺"}</label>)
            },
            {
                Header: "Tahsilat Durumu",
                accessor: "financialTransaction",
                sortable: false,
                Cell: item => (
                    <label>{(item.financialTransactionId === null) ? "TAHSİL EDİLMEDİ" : "TAHSİL EDİLDİ"}</label>)
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <Dropdown overlay={menu}
                                  trigger='click'
                                  onClick={() => this.setState({selectedItem: item})}
                        >
                            <Button style={{
                                background: '#3b6b96',
                                height: '30px',
                                width: '100px',
                                color: 'white',
                                borderRadius: '0.375em',
                                fontSize: "12px",
                            }}>
                                Seçiniz<Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                )
            }
        ];

        return (
            <div>
                {this.state.alert}
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="col-md-12 satirBasi">
                    <div className="card-header "/>
                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            content={this.state.accruals}
                            total={this.state.total}
                            page={this.state.page}
                            manual={this.state.manual}
                            size={this.state.size}
                            columns={columns}
                            fetchData={this.listAccruals}
                            style={{width:"100%", marginTop:"25px"}}
                        />
                    </div>
                    <div className="modal-footer">
                        <div className='col-sm-12 row' id="deleteModal">
                            <div className='col-sm-2'>
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"150px"}}
                                        rel="tooltip" className="TekBtn vazgec "
                                        onClick={this.cancelProcess}>
                                    İptal Et
                                </button>
                            </div>
                            <div className="col-sm-8"/>
                            <div className='col-sm-2'>
                                <button type="button" data-toggle="tooltip" data-placement="bottom"
                                        style={{
                                            background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                            float: 'right', padding: '10px 54px 10px 23px', width:"150px"
                                        }}
                                        rel="tooltip" className="TekBtn kaydet"
                                        onClick={() => this.addAccrual()}>
                                    Aidat Ekle
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.isOpen} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelMemberAccrualModal}>Aidat Düzenle </ModalHeader>
                    <ModalBody>
                        <EditMemberAccrualModal cancelProcess={this.cancelMemberAccrualModal}
                                                currentUser={this.props.currentUser}
                                                memberId={this.props.memberId}
                                                selectedAccrual={this.state.selectedAccrual}
                                                mode={this.state.mode}
                                                branches={this.props.branches}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addDeleteModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelMemberAccrualModal}>
                        Aidat Silme
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <AccuralDeleteModal
                            cancelProcess={this.cancelMemberAccrualModal}
                            selectedAccrual={this.state.selectedAccrual}
                            handleLogout={this.handleLogout}/>
                    </ModalBody>
                </Modal>
            </div>
        )
    }

}

export default MemberAccrualsModal


// WEBPACK FOOTER //
// ./src/page/memberList/MemberAccrualsModal.js